module.exports = __webpack_public_path__ + "static/media/pipeten.5cc9c1bc.jpg";